import React from 'react';
import { FORMULA_EQUATIONS, VARIABLE_BY_ID } from '../../data/formulas';
import { FormulaEquation } from '../../types';
import { Latex, InlineLatex } from './LatexRenderer';

interface FormulaCatalogViewProps {
  onSelectFormulaForSolver: (eq: FormulaEquation) => void;
}

export const FormulaCatalogView: React.FC<FormulaCatalogViewProps> = ({
  onSelectFormulaForSolver,
}) => {
  return (
    <div className="flex-1 overflow-y-auto p-6 space-y-6">
      <div className="border-b border-paper-300 pb-3 dark:border-study-line flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-serif text-xl font-bold text-zinc-900 dark:text-zinc-100">
            Prontuário de Fórmulas do Vestibular IFF
          </h2>
          <p className="text-xs text-zinc-500 dark:text-zinc-400">
            Catálogo consolidado das 43 relações matemáticas e físicas cobradas no edital e seus descritores oficiais.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <span className="font-mono text-xs text-zinc-400">Total: {FORMULA_EQUATIONS.length} fórmulas</span>
        </div>
      </div>

      {/* Grid of All Formulas */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {FORMULA_EQUATIONS.map((eq) => {
          const primary = { code: eq.descriptorCode, theme: '', description: '' };

          return (
            <div
              key={eq.id}
              className="flex flex-col justify-between rounded-xl border border-paper-300 bg-paper-50 p-4 shadow-sm dark:border-study-line dark:bg-study-card"
            >
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="rounded bg-paper-200 px-2 py-0.5 text-[10px] font-mono font-bold uppercase text-zinc-600 dark:bg-study-panel dark:text-zinc-400">
                    {eq.subject}
                  </span>
                  <span className="text-[10px] font-mono text-indigo-600 dark:text-indigo-400 font-bold">
                    {primary.code}
                  </span>
                </div>

                <h3 className="font-serif text-sm font-bold text-zinc-900 dark:text-zinc-100 leading-snug">
                  {eq.name}
                </h3>

                <div className="my-3 rounded bg-paper-100 py-3 text-center font-mono text-base text-indigo-700 dark:bg-study-slate dark:text-indigo-300">
                  <Latex>{eq.latex}</Latex>
                </div>

                <p className="text-xs leading-relaxed text-zinc-600 dark:text-zinc-400 font-sans">
                  {eq.description}
                </p>
              </div>

              <div className="mt-4 pt-2 border-t border-paper-200 dark:border-study-line flex flex-wrap items-center justify-between gap-1">
                <div className="flex flex-wrap gap-1">
                  {eq.variables.map((vid) => {
                    const vr = VARIABLE_BY_ID[vid];
                    if (!vr) return null;
                    return (
                      <span
                        key={vid}
                        className="rounded bg-paper-200 px-1.5 py-0.5 text-[10px] font-mono text-zinc-600 dark:bg-study-panel dark:text-zinc-400"
                        title={vr.name}
                      >
                        <InlineLatex>{vr.symbol}</InlineLatex>
                      </span>
                    );
                  })}
                </div>

                <button
                  type="button"
                  onClick={() => onSelectFormulaForSolver(eq)}
                  className="text-[10px] uppercase font-bold text-indigo-600 hover:text-indigo-800 dark:text-indigo-400"
                >
                  Testar no Grafo →
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
